import { ActionTypes } from './actions';

const initialState = {
    showAll: false,
};

export default function reviewsReducer(state = initialState, action) {
    switch (action.type) {
        case ActionTypes.SHOW_MORE_REVIEWS:
            return {
                ...state,
                showAll: true,
            };

        default:
            return state;
    }
}
